import { handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/login";

const FIND_ID = "find/FIND_ID"; // 아이디 찾기
const FIND_ID_PENDING = "find/FIND_ID_PENDING";
const FIND_ID_SUCCESS = "find/FIND_ID_SUCCESS";

const FIND_PW = "find/FIND_ID"; // 비밀번호 찾기

const CHANGE_PW = "find/CHANGE_PW"; // 비밀번호 변경

// const FIND_PW_SUCCESS = "find/FIND_ID_SUCCESS"; // 로그인 정보 전송

export const findId = createPromiseThunk(FIND_ID, api.findId);
export const findPw = createPromiseThunk(FIND_PW, api.findPw);
export const changePw = createPromiseThunk(CHANGE_PW, api.changePw);

const initialState = {
  userId: ""
};

export default handleActions(
  {
    [FIND_ID_PENDING]: (state, { payload }) => ({
      ...state,
      userId: ""
    }),
    [FIND_ID_SUCCESS]: (state, { payload }) => ({
      ...state,
      userId: payload.data.userId
    })
  },
  initialState
);
